//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from '../api/api'
import wechat from '../utils/wx'

export default {
    mounted(){
        document.body.style.background = "#fff";
        var self = this
//        this.$emit('header')
        this.getDetail(this.$route.params.id, (err, detailData) => {
            if (err) {
                this.alertContent=err;
                this.isShowAlert=true;
            } else {
                this.detailData = detailData

                window.__myWebLogTracker__ &&
                window.__myWebLogTracker__.report('微官网文章-详情-查看', {
                    id: detailData['data'].id,
                    name: detailData['data'].title
                });

                this.articleType = detailData['data']['articleType']
                if (self.articleType == 0) {
                    _vds.push(['setPageGroup', 'MyyCaseDetail'])

                } else {
                    _vds.push(['setPageGroup', 'MyyNewsDetail'])
                }

                _vds.push(['setPS1', self.$route.params.id])

                let timer = null
                let count = 0
                timer = setInterval(() => {
                    if ('trackPV' in _vds) {
                        clearInterval(timer)
                        _vds.trackPV()
                    }
                    if (count++ > 1000) {
                        clearInterval(timer)
                    }
                }, 100)
                setTimeout(() => {
                    self.loaded = true
                    self.$emit('footer', true)
                }, 200)
            }
        })

        this.$ajax.get(api.weixin, {
            params: {
                signurl: location.href.split('#')[0]
            }
        }).then(res => {
            this.wechatExist(function () {
                let share = wechat(wx)
                share.ready(void(0), {
                    title: self.detailData.data['title'], // 分享标题
                    desc: self.detailData.data['shareText'], // 分享描述
                    link: location.href, // 分享链接
                    imgUrl: self.detailData.data['banner'],
                    type: '', // 分享类型,music、video或link，不填默认为link
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                }, {
                    page: self.articleType == 0 ? 'MyyCaseDetail' : 'MyyNewsDetail',
                    id: self.$route.params.id
                })

                share.config(res['wx'])
            })
        })
    },
    data(){
        return {
            back: '<返回文章列表',
            readmore: '相关阅读>>',
            detailData: null,
            articleType: -1,
            loaded: false,
            isShowAlert:false, //是否显示错误弹框
            alertContent:""    //错误弹框内容
        }
    },
    beforeDestroy(){
        this.$emit('footer', false)
    },
    updated(){

    },
    watch: {
        '$route': function (to, from) {
            this.$mount()
        }
    },
    methods: {
        getDetail(id, cb){
            this.$ajax.get(api.detail, {
                params: {
                    id: id
                }
            }).then(res => {
                if (res['result'] && res['data']) {
                    if (cb) {
                        cb(false, res['data'])
                    }
                }
            }).catch(err => {
                if (cb) {
                    cb(err)
                }
            })
        },

        hideAlert(){
            this.isShowAlert=false;
        },

        _link(id){
            if (id) {
                window.open('/myy/detail/' + id, '_self')
            }
        },

        _back(){
            this.$router.push({
                name: 'List',
                params: {
                    type: this.articleType
                }
            })
        },

        wechatExist(cb){
            let timer = null;
            timer = setInterval(() => {
                if ('wx' in window) {
                    clearInterval(timer)
                    if (cb) {
                        cb()
                    }
                }
            }, 200)
        },

    }
}



// WEBPACK FOOTER //
// ./src/components/detail.vue